import { Divider, Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { IBillingInfo } from '../Type/invoiceVisa.interface';
import BillingAndPassInfoForm from './BillingAndPassInfoForm';
import FormHeaderTitle from './FormHeaderTitle';

type Props = {
  form: FormInstance<any>;
  billing_information?: IBillingInfo[];
  conditionalCostVendor?: boolean;
};

export default function BillingFormList({
  form,
  billing_information,
  conditionalCostVendor,
}: Props) {
  return (
    <div className='border p-5 my-20'>
      <FormHeaderTitle title='Billing Information' />
      <Form.List name='billing_information' initialValue={[{}]}>
        {(fields, { add, remove }) =>
          fields.map((field, index) => {
            return (
              <Row
                key={index}
                style={{ display: 'flex', alignItems: 'center' }}
                gutter={[10, { xs: 8, sm: 16, md: 24, lg: 20 }]}
              >
                <>
                  {index !== 0 ? (
                    <Divider
                      orientation='left'
                      style={{ borderColor: '#44403C' }}
                    >{`Billing Information #${index + 1}`}</Divider>
                  ) : (
                    ''
                  )}
                  <BillingAndPassInfoForm
                    form={form}
                    add={add}
                    field={field}
                    index={index}
                    remove={remove}
                    billing_information={billing_information}
                    conditionalCostVendor={conditionalCostVendor}
                  />
                </>
              </Row>
            );
          })
        }
      </Form.List>
    </div>
  );
}
